/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';

const initialState = {
  invoicesQtrnotPaidObj: {},
  invoicesQtrnotPaidDetailObj: {},
  errorMsgQtrlyPayment: [],
  planType: [],
  quarter: '',
  rebateProgram: [],
  searchResult: [],
  invoiceDetailsByInvoiceNum: {},
  extraState: {
    searchPage: true,
    detailPage: true,
  },
  displayData: {
    rebateProgram: '',
    quarter: '',
    payValue: 'Bal>0',
    amtPercent: '',
    exUnThreshMailed: true,
    incZeroURA: true,
    excDecBalWtnOff: true,
    searchResult: [],
    rebateProgram: [],
    rebateProgrameName: '',
    invoiceDetailsByInvoiceNum: {},
    rebateProgrameName: '',
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_INV_QTR_NOT_PAID_DISPLAY_OBJ:
      return { ...state, invoicesQtrnotPaidObj: action.screenData };
    case actionTypes.GET_INV_QTR_NOT_PAID_DETAIL_OBJ:
      return { ...state, invoicesQtrnotPaidDetailObj: action.detailScrData };
    case actionTypes.GET_ERROR_MSG_INV_QTR_NOT_PAID:
      return { ...state, errorMsgQtrlyPayment: action.payload };
    case actionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    // case actionTypes.GET_REBATE_PROGRAM:
    //   return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_INVOICE_QTR_NOT_PAID_DATA:
      const displayData = {
        ...state.displayData,
        searchResult: action.payload.data,
      };
      return {
        ...state,
        searchResult: action.payload.data,
        displayData: {
          ...state.displayData,
          ...action.payload.value2,
          displayData,
        },
      };
    case actionTypes.DISPLAY_INV_QTR_NOT_PAID_INPUT_FIELD:
      return { ...state, displayData: action.payload };
    case actionTypes.GET_REBATE_QUARTER_VALUE:
      return { ...state, quarter: action.payload };
    case actionTypes.SET_INVOICE_FOR_QTR_NOT_PAID_EXTRA_STATE:
      return { ...state, extraState: action.extraState };
    case actionTypes.GET_INVOICE_DETAILS_BY_INVOICE_NUM: {
      return {
        ...state,
        invoiceDetailsByInvoiceNum:
          typeof action.payload?.data === 'string' &&
          action.payload?.data?.includes('No record')
            ? state.invoiceDetailsByInvoiceNum
            : action.payload,
        noRecordFound: !!(
          typeof action.payload?.data === 'string' &&
          action.payload?.data?.includes('No record')
        ),
        searchClicked: !state.searchClicked,
      };
    }

    case actionTypes.REFRESH_INVOICE_QTR_NOT_PAID:
      return {
        ...state,
        invoicesQtrnotPaidObj: {},
        invoicesQtrnotPaidDetailObj: {},
        errorMsgQtrlyPayment: [],
        planType: [],
        quarter: '',
        rebateProgram: [],
        searchResult: [],
        invoiceDetailsByInvoiceNum: {},
        extraState: {
          searchPage: true,
          detailPage: true,
        },
      };
    case actionTypes.REFRESH_INVOICE_QTR_NOT_PAID_DISPLAY:
      return {
        ...state,
        quarter: '',
        payValue: 'Bal>0',
        amtPercent: '',
        exUnThreshMailed: true,
        incZeroURA: true,
        excDecBalWtnOff: true,
        plan: '',
        invoicesQtrnotPaidDetailObj: {},
        errorMsgQtrlyPayment: [],
        // planType: [],
        rebateProgram: [],
        searchResult: [],
        invoiceDetailsByInvoiceNum: {},
      };
       case actionTypes.RESET_INVOICE_QTR_NOT_PAID:
        return {
      ...initialState,
  };
    default:
      return state;
  }
};
export default reducer;
